import React from 'react';
import { Route, BrowserRouter, Routes } from 'react-router-dom'

// components

// pages
import Static from '../pages/Static';
import Homepage from '../pages/Homepage';
import Feedback from '../pages/Feedback';

function Main() {
  return (

    <main id="maincontent">
      <section id="main">
        <BrowserRouter>
          <Routes>
              <Route path="/" element={ <Homepage />} />
              <Route path="/feedback" element={ <Feedback />} />
              <Route path="/static" element={ <Static />} />
           </Routes>
        </BrowserRouter>
      </section>
    </main>

  );
}

export default Main;